import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import * as React from 'react';
import { FocusOn } from 'react-focus-on';
import { useId } from 'react-id-generator';
import styled from 'styled-components';
import { KEYS } from '../../../constants/keys.js';
import { useTranslations } from '../../../hooks/use_translations.js';
import { spacing4x, spacing8x } from '../../../styles/spacing.js';
import { useThemeContext } from '../../../styles/themes/themes.js';
import { Box } from '../../Box/Box.js';
import { Button } from '../../Button/Button.js';
import '../../Icons/IconActivity.js';
import '../../Icons/IconActivityFilled.js';
import '../../Icons/IconActivityOff.js';
import '../../Icons/IconAdd.js';
import '../../Icons/IconAddToCart.js';
import '../../Icons/IconAlignBottom.js';
import '../../Icons/IconAlignCenter.js';
import '../../Icons/IconAlignJustify.js';
import '../../Icons/IconAlignLeft.js';
import '../../Icons/IconAlignMiddle.js';
import '../../Icons/IconAlignRight.js';
import '../../Icons/IconAlignTop.js';
import '../../Icons/IconAnnotate.js';
import '../../Icons/IconApps.js';
import '../../Icons/IconArchive.js';
import '../../Icons/IconArrowBack.js';
import '../../Icons/IconArrowDown.js';
import '../../Icons/IconArrowLeft.js';
import '../../Icons/IconArrowRight.js';
import '../../Icons/IconArrowUp.js';
import '../../Icons/IconAskExpert.js';
import '../../Icons/IconAtMention.js';
import '../../Icons/IconAttach.js';
import '../../Icons/IconBarChart.js';
import '../../Icons/IconBold.js';
import '../../Icons/IconCalendar.js';
import '../../Icons/IconCalendarDay.js';
import '../../Icons/IconCaretDown.js';
import '../../Icons/IconCaretUp.js';
import '../../Icons/IconCertification.js';
import '../../Icons/IconCheck.js';
import { IconClose } from '../../Icons/IconClose.js';
import '../../Icons/IconCloseContextualPanel.js';
import '../../Icons/IconCloudSync.js';
import '../../Icons/IconCloudUpload.js';
import '../../Icons/IconCode.js';
import '../../Icons/IconCollapsePanel.js';
import '../../Icons/IconCollection.js';
import '../../Icons/IconColor.js';
import '../../Icons/IconColumns.js';
import '../../Icons/IconComment.js';
import '../../Icons/IconContentPlanner.js';
import '../../Icons/IconCopy.js';
import '../../Icons/IconCorporations.js';
import '../../Icons/IconCRM.js';
import '../../Icons/IconCustomDelivery.js';
import '../../Icons/IconCustomize.js';
import '../../Icons/IconDash.js';
import '../../Icons/IconDatasource.js';
import '../../Icons/IconDelete.js';
import '../../Icons/IconDependentField.js';
import '../../Icons/IconDocCenter.js';
import '../../Icons/IconDownload.js';
import '../../Icons/IconDrag.js';
import '../../Icons/IconEdit.js';
import '../../Icons/IconEditForm.js';
import '../../Icons/IconEditNew.js';
import '../../Icons/IconEmail.js';
import '../../Icons/IconEmailBlast.js';
import '../../Icons/IconEmailComponent.js';
import '../../Icons/IconEmailTemplate.js';
import '../../Icons/IconEmoji.js';
import '../../Icons/IconEngagements.js';
import '../../Icons/IconEvent.js';
import '../../Icons/IconExpire.js';
import '../../Icons/IconExport.js';
import '../../Icons/IconExternal.js';
import '../../Icons/IconFavoriteSelected.js';
import '../../Icons/IconFavoriteUnselected.js';
import '../../Icons/IconFile.js';
import '../../Icons/IconFileAdd.js';
import '../../Icons/IconFileEdit.js';
import '../../Icons/IconFileLock.js';
import '../../Icons/IconFileMove.js';
import '../../Icons/IconFileRemove.js';
import '../../Icons/IconFileSearch.js';
import '../../Icons/IconFileShare.js';
import '../../Icons/IconFileStar.js';
import '../../Icons/IconFileSync.js';
import '../../Icons/IconFileZip.js';
import '../../Icons/IconFilter.js';
import '../../Icons/IconFolder.js';
import '../../Icons/IconFolderAdd.js';
import '../../Icons/IconFolderEdit.js';
import '../../Icons/IconFolderOpen.js';
import '../../Icons/IconFolderRemove.js';
import '../../Icons/IconFolderSearch.js';
import '../../Icons/IconFolderShare.js';
import '../../Icons/IconFolderStar.js';
import '../../Icons/IconFolderSync.js';
import '../../Icons/IconFolderTeam.js';
import '../../Icons/IconFolderZip.js';
import '../../Icons/IconFullscreen.js';
import '../../Icons/IconGenericSort.js';
import '../../Icons/IconGlobal.js';
import '../../Icons/IconGoogleDrive.js';
import '../../Icons/IconGrid.js';
import '../../Icons/IconGridPattern1.js';
import '../../Icons/IconGroupBy.js';
import '../../Icons/IconHandClosed.js';
import '../../Icons/IconHandOpen.js';
import '../../Icons/IconHome.js';
import '../../Icons/IconIndentDecrease.js';
import '../../Icons/IconIndentIncrease.js';
import '../../Icons/IconInsights.js';
import '../../Icons/IconIntegrations.js';
import '../../Icons/IconInternalSync.js';
import '../../Icons/IconItalic.js';
import '../../Icons/IconLaptop.js';
import '../../Icons/IconLayout.js';
import '../../Icons/IconLearningJourney.js';
import '../../Icons/IconLesson.js';
import '../../Icons/IconLibrary.js';
import '../../Icons/IconLightbulb.js';
import '../../Icons/IconLike.js';
import '../../Icons/IconLikeDisabled.js';
import '../../Icons/IconLineChart.js';
import '../../Icons/IconLineHeight.js';
import '../../Icons/IconLink.js';
import '../../Icons/IconList.js';
import '../../Icons/IconListNumbers.js';
import '../../Icons/IconLiveSocial.js';
import '../../Icons/IconLocate.js';
import '../../Icons/IconLock.js';
import '../../Icons/IconLogic.js';
import '../../Icons/IconMedia.js';
import '../../Icons/IconMediaCC.js';
import '../../Icons/IconMediaCCActive.js';
import '../../Icons/IconMediaControlPrevious.js';
import '../../Icons/IconMediaForward.js';
import '../../Icons/IconMediaFull.js';
import '../../Icons/IconMediaLow.js';
import '../../Icons/IconMediaMedium.js';
import '../../Icons/IconMediaMute.js';
import '../../Icons/IconMediaNext.js';
import '../../Icons/IconMediaPause.js';
import '../../Icons/IconMediaPlay.js';
import '../../Icons/IconMediaRewind.js';
import '../../Icons/IconMediaStop.js';
import '../../Icons/IconMeetings.js';
import '../../Icons/IconMenu.js';
import '../../Icons/IconModule.js';
import '../../Icons/IconMore.js';
import '../../Icons/IconMove.js';
import '../../Icons/IconMultiSelect.js';
import '../../Icons/IconNews.js';
import '../../Icons/IconNumeric.js';
import '../../Icons/IconOpenContextualPanel.js';
import '../../Icons/IconOpenPanel.js';
import '../../Icons/IconPage.js';
import '../../Icons/IconPageBack.js';
import '../../Icons/IconPageDown.js';
import '../../Icons/IconPageForward.js';
import '../../Icons/IconPageUp.js';
import '../../Icons/IconPaperclip.js';
import '../../Icons/IconParagraph.js';
import '../../Icons/IconPath.js';
import '../../Icons/IconPieChart.js';
import '../../Icons/IconPin.js';
import '../../Icons/IconPortfolio.js';
import '../../Icons/IconPresentation.js';
import '../../Icons/IconPresentationMode.js';
import '../../Icons/IconPreview.js';
import '../../Icons/IconPreviewOff.js';
import '../../Icons/IconPrint.js';
import '../../Icons/IconProject.js';
import '../../Icons/IconPublish.js';
import '../../Icons/IconPublishing.js';
import '../../Icons/IconPushNotification.js';
import '../../Icons/IconPuzzlePiece.js';
import '../../Icons/IconQuote.js';
import '../../Icons/IconRecord.js';
import '../../Icons/IconRecordActive.js';
import '../../Icons/IconRedo.js';
import '../../Icons/IconRefresh.js';
import '../../Icons/IconRemoveFormatting.js';
import '../../Icons/IconReorder.js';
import '../../Icons/IconRequest.js';
import '../../Icons/IconRotate.js';
import '../../Icons/IconRSS.js';
import '../../Icons/IconSave.js';
import '../../Icons/IconScreen.js';
import '../../Icons/IconScreenFitHeight.js';
import '../../Icons/IconScreenFitWidth.js';
import '../../Icons/IconScreenNext.js';
import '../../Icons/IconScreenPrevious.js';
import '../../Icons/IconScreenShare.js';
import '../../Icons/IconSearch.js';
import '../../Icons/IconSettings.js';
import '../../Icons/IconShare.js';
import '../../Icons/IconSharedLink.js';
import '../../Icons/IconSingleSelect.js';
import '../../Icons/IconSortDown.js';
import '../../Icons/IconSortUp.js';
import '../../Icons/IconSoundOff.js';
import '../../Icons/IconSoundOn.js';
import '../../Icons/IconStatusAdd.js';
import '../../Icons/IconStatusAddFilled.js';
import '../../Icons/IconStatusCheck.js';
import '../../Icons/IconStatusCheckFilled.js';
import '../../Icons/IconStatusClose.js';
import '../../Icons/IconStatusCloseFilled.js';
import '../../Icons/IconStatusDot.js';
import '../../Icons/IconStatusError.js';
import '../../Icons/IconStatusHelp.js';
import '../../Icons/IconStatusHelpFilled.js';
import '../../Icons/IconStatusInformation.js';
import '../../Icons/IconStatusInformationFilled.js';
import '../../Icons/IconStatusPause.js';
import '../../Icons/IconStatusPauseFilled.js';
import '../../Icons/IconStatusPlay.js';
import '../../Icons/IconStatusPlayFilled.js';
import '../../Icons/IconStatusRemove.js';
import '../../Icons/IconStatusRemoveFilled.js';
import '../../Icons/IconStatusUrgent.js';
import '../../Icons/IconStatusUrgentFilled.js';
import '../../Icons/IconStatusWarning.js';
import '../../Icons/IconSubtask.js';
import '../../Icons/IconSync.js';
import '../../Icons/IconTableColumn.js';
import '../../Icons/IconTableGrid.js';
import '../../Icons/IconTableRow.js';
import '../../Icons/IconTags.js';
import '../../Icons/IconTask.js';
import '../../Icons/IconTasks.js';
import '../../Icons/IconTaxonomy.js';
import '../../Icons/IconTemplate.js';
import '../../Icons/IconText.js';
import '../../Icons/IconTextCleared.js';
import '../../Icons/IconTextField.js';
import '../../Icons/IconTextImageLeft.js';
import '../../Icons/IconTextImageRight.js';
import '../../Icons/IconTextIndentLeft.js';
import '../../Icons/IconTextIndentRight.js';
import '../../Icons/IconTextSingle.js';
import '../../Icons/IconTextSize.js';
import '../../Icons/IconTextStrikethrough.js';
import '../../Icons/IconTextSubscript.js';
import '../../Icons/IconTextSuperscript.js';
import '../../Icons/IconTextUnderline.js';
import '../../Icons/IconTrendingDown.js';
import '../../Icons/IconTrendingUp.js';
import '../../Icons/IconTrueFalse.js';
import '../../Icons/IconTv.js';
import '../../Icons/IconTwoColumn.js';
import '../../Icons/IconUndo.js';
import '../../Icons/IconUnlike.js';
import '../../Icons/IconUnlink.js';
import '../../Icons/IconUnlock.js';
import '../../Icons/IconUnpublish.js';
import '../../Icons/IconUpload.js';
import '../../Icons/IconUser.js';
import '../../Icons/IconUserAdd.js';
import '../../Icons/IconUserAddToMeeting.js';
import '../../Icons/IconUserGroup.js';
import '../../Icons/IconUserRating.js';
import '../../Icons/IconUserRemove.js';
import '../../Icons/IconUserSearch.js';
import '../../Icons/IconUserSettings.js';
import '../../Icons/IconUserShare.js';
import '../../Icons/IconUserSync.js';
import '../../Icons/IconVariables.js';
import '../../Icons/IconVideo.js';
import '../../Icons/IconVideoPause.js';
import '../../Icons/IconVideoRewind15.js';
import '../../Icons/IconVideoSkip15.js';
import '../../Icons/IconWorkspace.js';
import '../../Icons/IconZoomIn.js';
import '../../Icons/IconZoomOut.js';
import { LinkButton } from '../../LinkButton/LinkButton.js';
import { POPOVER_DATA_TESTIDS } from '../constants.js';
import { jsx, jsxs } from 'react/jsx-runtime';

var Container = styled(Box).withConfig({
  displayName: "PopoverDialog__Container",
  componentId: "sc-16pey41-0"
})(["&&{padding:", ";max-width:400px;outline:none;}"], spacing4x);
var HeaderContainer = styled.div.withConfig({
  displayName: "PopoverDialog__HeaderContainer",
  componentId: "sc-16pey41-1"
})(["&&{display:flex;justify-content:space-between;align-items:center;margin-block-end:20px;}"]);
var Header = styled.div.withConfig({
  displayName: "PopoverDialog__Header",
  componentId: "sc-16pey41-2"
})(["&&{display:flex;align-items:center;color:", ";font-weight:600;font-size:16px;line-height:24px;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.neutralColors.charcoal;
});
var Footer = styled.div.withConfig({
  displayName: "PopoverDialog__Footer",
  componentId: "sc-16pey41-3"
})(["&&{display:flex;justify-content:space-between;align-items:center;gap:", ";margin-block-start:", ";}"], spacing4x, spacing8x);
var FooterCTAs = styled.div.withConfig({
  displayName: "PopoverDialog__FooterCTAs",
  componentId: "sc-16pey41-4"
})(["&&{display:flex;align-items:center;gap:16px;}"]);
var PopoverDialog = /*#__PURE__*/React.forwardRef(function (_ref2, ref) {
  var ariaLabel = _ref2.ariaLabel,
    className = _ref2.className,
    content = _ref2.content,
    CTAs = _ref2.CTAs,
    header = _ref2.header,
    hideDismissButton = _ref2.hideDismissButton,
    hidePopover = _ref2.hidePopover,
    popoverId = _ref2.popoverId,
    style = _ref2.style,
    tertiaryAction = _ref2.tertiaryAction;
  var headerId = useId(1, "popover-header-")[0];
  var contentId = useId(1, "popover-content-")[0];
  var _useThemeContext = useThemeContext(),
    localization = _useThemeContext.localization;
  var _useTranslations = useTranslations(localization === null || localization === void 0 ? void 0 : localization.translations),
    t = _useTranslations.t;
  var onKeyDown = React.useCallback(function (e) {
    e.stopPropagation();
    if (e.key === KEYS.ESCAPE) hidePopover();
  }, [hidePopover]);
  return /*#__PURE__*/jsx(FocusOn, {
    children: /*#__PURE__*/jsxs(Container, {
      "aria-label": ariaLabel,
      "aria-labelledby": ariaLabel ? void 0 : headerId,
      "aria-describedby": contentId,
      "aria-modal": "true",
      borderRadius: 2,
      className: className,
      elevation: 3,
      id: popoverId,
      onKeyDown: onKeyDown,
      ref: ref,
      role: "dialog",
      style: style,
      tabIndex: 0,
      children: [(header || !hideDismissButton) && /*#__PURE__*/jsxs(HeaderContainer, {
        "data-testid": POPOVER_DATA_TESTIDS.dialogHeaderContainer,
        children: [/*#__PURE__*/jsx(Header, {
          "data-testid": POPOVER_DATA_TESTIDS.dialogHeader,
          id: headerId,
          children: header
        }), !hideDismissButton && /*#__PURE__*/jsx(Button, {
          hideLabel: true,
          iconSize: 16,
          label: t("Popover.dismissButton"),
          onClick: hidePopover,
          startAdornment: IconClose,
          variant: "ghost"
        })]
      }), /*#__PURE__*/jsx("div", {
        "data-testid": POPOVER_DATA_TESTIDS.dialogContent,
        id: contentId,
        children: content
      }), (CTAs || tertiaryAction) && /*#__PURE__*/jsxs(Footer, {
        "data-testid": POPOVER_DATA_TESTIDS.dialogFooter,
        children: [/*#__PURE__*/jsx("div", {
          children: tertiaryAction && /*#__PURE__*/jsx(LinkButton, _objectSpread({}, tertiaryAction))
        }), /*#__PURE__*/jsx(FooterCTAs, {
          children: CTAs === null || CTAs === void 0 ? void 0 : CTAs.map(function (ctaProps, index) {
            return /*#__PURE__*/jsx(LinkButton, _objectSpread({}, ctaProps), index);
          })
        })]
      })]
    })
  });
});
PopoverDialog.displayName = "PopoverDialog";

export { PopoverDialog };
